import request from '@/utils/request'

export function getSystemConfig(name) {
    return request({
        url: `/config/list/${name}`,
        method: 'get'
    })
}
